import { Component } from '@angular/core';

@Component({
  selector: 'app-recruiter-program',
  templateUrl: './recruiter-program.component.html',
  styleUrls: ['./recruiter-program.component.scss'],
})
export class RecruiterProgramComponent {}
